export default __webpack_public_path__ + "static/media/pension_light.647d23ad.png";